import React, { useEffect, useState } from 'react'

import { getBackendData } from '../../api/api'
import { INewAdresses } from '../../api/interfaces'
import { IChart } from '../../components/Chart/interface'
import LoadingChart from '../../components/LoadingIcon/Loading'
import ChartPage from '../../pages/ChartPage/ChartPage'
import { useChartData } from '../../hooks/useChartData'

async function getNewAddressesConfig(color: string, inverseColor: string, timeframe: string) {
	const chartData = (await getBackendData('thorchain', 'tc_new_adds', timeframe)) as INewAdresses[]
	const series1 = chartData.map((element: INewAdresses) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.NEW_ADDRESSES }
	})
	const series2 = chartData.map((element: INewAdresses) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.NEW_ADDRESSES_CUMULATIVE }
	})
	const config: IChart[] = [
		{
			data: series1,
			strokeWidth: 2,
			name: 'new addresses',
			type: 'bars',
			seriesGroup: '[address #]',
			color: 'green'
		},
		{
			data: series2,
			strokeWidth: 2,
			name: 'new addresses cumulative',
			type: 'line',
			seriesGroup: ' [address #]',
			color: 'orange'
		}
	]
	return { config: config, latestValue: series2[series2.length - 1].y, latestValueDate: series2[series2.length - 1].x }
}
const NewAddresses = () => {
	const { dataSeries, timeframe, setTimeframe, isLoading, error, retry } = useChartData(getNewAddressesConfig)

	if (error) {
		return (
			<div style={{ padding: 40, textAlign: 'center' }}>
				<p>Error loading chart: {error}</p>
				<button onClick={retry}>Retry</button>
			</div>
		)
	}

	if (isLoading || dataSeries === undefined) {
		return <LoadingChart />
	}
	return (
		<ChartPage
			chartTitle="New Addresses"
			chartDesc="The daily count of newly created unique addresses that interact with THORChain for the first time. Useful for tracking network growth and user onboarding trends."
			chartDescTitle="Metric Description"
			chartData={dataSeries.config}
			queryId="bb5e8f96-ed45-46b0-aa4d-e5b8006f4699"
			timeframe={timeframe}
			setTimeframe={setTimeframe}
			hasHours={false}
			reverseLegend={true}
		/>
	)
}

export default NewAddresses
